import { useReplicacheQueryV2 } from '~/hooks-data/use-replicache-query'
import { repoSpaceMutators } from '@basehub/data/replicache/mutators/repo-space/mutators'
import { useRepoReplicache } from '~/hooks-data/use-repo-replicache'
import { invariant } from '@epic-web/invariant'

export const useBranchQuery = ({ id }: { id: string | undefined }) => {
  const { replicache } = useRepoReplicache().data ?? {}

  const query = useReplicacheQueryV2({
    key: ['branch', id],
    replicache,
    fetcher: async (tx) => {
      invariant(id, 'shouldnt be enabled')
      return (await repoSpaceMutators.getBranch(tx, id)) ?? null
    },
    enabled: !!id,
    keepPreviousData: true,
  })

  return query
}
